import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const HouseKeeping = () => {
  const names = ['Attendance', 'Man Power Deployment', 'Quality Checking & Control(QCS)',
    'Machine Operations(MCOPR)'];

  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={1}>
           {hasModulePermission("MPR Calendar") && ( 
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link={{ pathname: '/operations/menpower-calendar' }}
              permissions={permissions}
              title="MPR Calendar"
            />
             )}
            {hasModulePermission("MP Attendance") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link={{ pathname: '/operations/attandancetable' }}
              title="MP Attendance"
              permissions={permissions}

            />
           )}
            {hasModulePermission("Man Power Deployment") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              permissions={permissions}
              // link="#"
               link={{ pathname: '/operations/menpowertable' }}
              title="Man Power Deployment"
            />
            )}
            {hasModulePermission("Task/Work Entry") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              permissions={permissions}
               link={{ pathname: '/operations/weeklyallocation' }}
              title="Task/Work Entry"
            />
               )}
            {hasModulePermission("Quality Checking & Control(QCS)") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link="#"
                // link={{ pathname: '/' }}
                title="Quality Checking & Control(QCS)"
              />
            )}

            {/* {hasModulePermission("Machine Operations(MCOPR)") && ( */}
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Machine Operations(MCOPR)"
            />
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>

          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default HouseKeeping;